import type {AfriexProcessor, ProcessorFlagMeta} from '@/types';

import type {ProductionStatus} from './productionStatus';

/** The Production filter: a processor's overall status, or no status yet. */
export type ProductionStatusFilter = ProductionStatus | 'UNKNOWN' | 'ALL';

export type ProcessorListProps = {
  isLoading: boolean;
  /** Whatever the fetch caught. */
  error: unknown;
  /** The current page of processors matching the search and filter. */
  list: AfriexProcessor[];
  /** How many processors match the search and filter, across all pages. */
  total: number;
  setPage: (page: number) => void;
  /** Toggles whenever the matching set changes, so Pagination returns to page 1. */
  isPageReset: boolean;
  isSearch: boolean;
  searchTerm: string;
  handleSearch: (term: string) => void;
  statusFilter: ProductionStatusFilter;
  handleStatusFilter: (status: ProductionStatusFilter) => void;
  /** How many processors have each status, for the filter's labels. */
  statusCounts: Record<ProductionStatusFilter, number>;
};

export enum ProcessorActionType {
  UPDATE_PROCESSOR = 'UPDATE_PROCESSOR',
  UPDATE_META = 'UPDATE_META',
  UPDATE_FLAGS = 'UPDATE_FLAGS',
}

interface UpdateProcessorAction {
  type: ProcessorActionType.UPDATE_PROCESSOR;
  payload: Partial<AfriexProcessor>;
}

interface UpdateMetaAction {
  type: ProcessorActionType.UPDATE_META;
  payload: Partial<AfriexProcessor['meta']>;
}

interface UpdateFlagsAction {
  type: ProcessorActionType.UPDATE_FLAGS;
  payload: Partial<ProcessorFlagMeta>;
}

export type ProcessorAction =
  UpdateProcessorAction | UpdateMetaAction | UpdateFlagsAction;
